import React from 'react';
import styled from 'styled-components';
import { Header } from '@app/navigation/header';
import { Body, Body1, Container, Page } from '@ui';
import { AI_TOOLS } from '@constants';
import { ROUTES } from '@constants/routes';
import { useNavigate } from 'react-router';
import BackArrowButton from '@ui/buttons/BackArrowButton';
import { AdvancedSettingsButton } from '@containers/DigitalAnalyst/AdvancedSettings';
import { AdvancedSettingsProvider } from '@/contexts/AdvancedSettingsContext';
import { ModeContext } from '@/contexts/ModeContext';
import { QuerySeriesProvider } from '@/contexts/QuerySeriesContext';
import { QuerySeriesMode } from '@features/querySeries/QuerySeriesMode';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 16px;
`;

// const startingQuestions = []
const startingQuestions = [
  {
    question:
      'Provide a brief overview of the Firm, including information on the founding, subsequent history and information on any predecessor firm and/or parent firm and/or merger firm.',
    displayQuestion:
      'Provide a brief overview of the Firm, including information on the founding, subsequent history and information on any predecessor firm and/or parent firm and/or merger firm.',
  },
  {
    question:
      'Describe the background and evolution of the Firm’s investment strategy. Provide a timeline  of  this evolution, including when any additional strategic platforms were added to the Firm’s offerings. Provide examples of investments that demonstrate this evolution.',
    displayQuestion:
      'Describe the background and evolution of the Firm’s investment strategy. Provide a timeline  of  this evolution, including when any additional strategic platforms were added to the Firm’s offerings. Provide examples of investments that demonstrate this evolution.',
  },
  {
    question:
      'Please provide details of the strategies and activities conducted by the Manager, subsidiaries and its subdivisions/branches. Please list the subsidiaries, branch offices or other locations, if any.',
    displayQuestion:
      'Please provide details of the strategies and activities conducted by the Manager, subsidiaries and its subdivisions/branches. Please list the subsidiaries, branch offices or other locations, if any.',
  },
  {
    question:
      'Describe any plans to change or expand the Firm (e.g., entering/exiting business lines or office locations or WFH/remote) over the next five (5) years.',
    displayQuestion:
      'Describe any plans to change or expand the Firm (e.g., entering/exiting business lines or office locations or WFH/remote) over the next five (5) years.',
  },
];
const tool = AI_TOOLS.QUERY_SERIES;

const modeContext = {
  tool,
  promptSuffix:
    'When answering the question, only answer in JSON in the following format: { "reasoning": "reasoning", "answer": "answer" }',
  startingQuestions,
};

export function QuerySeries() {
  const navigate = useNavigate();
  const goBackOverrideRef = React.useRef(null);

  const onGoBack = () => {
    if (goBackOverrideRef.current) {
      goBackOverrideRef.current();
    } else {
      navigate(ROUTES.home);
    }
  };

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <Page width={1800}>
          <BackArrowButton onClick={onGoBack} />
          <AdvancedSettingsButton tool={tool} />

          <Container top={40}>
            <ModeContext.Provider value={modeContext}>
              <AdvancedSettingsProvider>
                <HeadingWrapper>
                  <Body1 bold>Digital Analyst</Body1>
                </HeadingWrapper>
                <QuerySeriesProvider>
                  <QuerySeriesMode goBackOverrideRef={goBackOverrideRef} />
                </QuerySeriesProvider>
              </AdvancedSettingsProvider>
            </ModeContext.Provider>
          </Container>
        </Page>
      </Body>
    </PageWrapper>
  );
}
